export const SUPERSEDED_TAB_MESSAGE =
  "Questa scheda non è più attiva. Continua dall'ultima scheda di autenticazione aperta.";

/**
 * Best-effort: il browser di solito ignora close() sulle schede aperte dall'utente.
 * L'UX reale è l'overlay `isSuperseded` in `App`.
 */
export function tryCloseBrowserTab(): void {
  // Per ora non chiudiamo le schede dal coordinator.
  // try {
  //   window.close();
  // } catch {
  //   // ignore
  // }
}
